import React from "react";
import { usePermissions, useTranslate } from "react-admin";
import { Button, Typography, useTheme } from "@material-ui/core";
import { UserRole } from "../../../entities";

export interface ConfiguredEmptyStateProps {
  terminalId: string | null;
  error?: string | null;
  onRequestEditor?: () => void;
}

export const ConfiguredEmptyState: React.FC<ConfiguredEmptyStateProps> = ({
  terminalId,
  error,
  onRequestEditor,
}) => {
  const theme = useTheme();
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const isAdmin = permissions && permissions.role === UserRole.admin;


  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flex: 1,
        minHeight: 0,
        alignItems: "center",
        justifyContent: "center",
        background: theme.palette.storageUi.backgroundPrimary,
      }}
    >
      <div style={{ textAlign: "center", color: theme.palette.secondary.main }}>
        {terminalId ? (
          <div>
            <Typography variant="h5" color="inherit" gutterBottom>
              {translate("osfc.storage_ui.configured_empty.no_config")}
            </Typography>
            <Typography variant="body1" color="inherit">
              {translate("osfc.storage_ui.configured_empty.upload_editor")}
            </Typography>
            {(error === "NO_CONFIG_FOUND" || error === "LOAD_ERROR") && isAdmin && (
              <div style={{ marginTop: 12 }}>
                <Button
                  onClick={() => onRequestEditor && onRequestEditor()}
                  color="secondary"
                  variant="outlined"
                >
                  {translate("osfc.storage_ui.configured_empty.go_to_editor")}
                </Button>
              </div>
            )}
          </div>
        ) : (
          <Typography variant="h5" color="inherit">
            {translate("osfc.storage_ui.configured_empty.select_terminal")}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default ConfiguredEmptyState;
